// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivityFeedController from "./activity_feed_controller"
application.register("activity-feed", ActivityFeedController)

import ActivityFormController from "./activity_form_controller"
application.register("activity-form", ActivityFormController)

import ActivityTabsController from "./activity_tabs_controller"
application.register("activity-tabs", ActivityTabsController)

import AiChatController from "./ai_chat_controller"
application.register("ai-chat", AiChatController)

import AirdropReportViewerController from "./airdrop_report_viewer_controller"
application.register("airdrop-report-viewer", AirdropReportViewerController)

import AirlockDropzoneController from "./airlock_dropzone_controller"
application.register("airlock-dropzone", AirlockDropzoneController)

import AlbumController from "./album_controller"
application.register("album", AlbumController)

import AlbumImageSortableController from "./album_image_sortable_controller"
application.register("album-image-sortable", AlbumImageSortableController)

import AlbumsViewToggleController from "./albums_view_toggle_controller"
application.register("albums-view-toggle", AlbumsViewToggleController)

import AllCardsColumnsController from "./all_cards_columns_controller"
application.register("all-cards-columns", AllCardsColumnsController)

import AtlasController from "./atlas_controller"
application.register("atlas", AtlasController)

import AttachResultModalController from "./attach_result_modal_controller"
application.register("attach-result-modal", AttachResultModalController)

import BarChartController from "./bar_chart_controller"
application.register("bar-chart", BarChartController)

import BaySizesClientFilterController from "./bay_sizes_client_filter_controller"
application.register("bay-sizes-client-filter", BaySizesClientFilterController)

import BeaconBootstrapController from "./beacon_bootstrap_controller"
application.register("beacon-bootstrap", BeaconBootstrapController)

import BeaconPairingController from "./beacon_pairing_controller"
application.register("beacon-pairing", BeaconPairingController)

import BoomboxController from "./boombox_controller"
application.register("boombox", BoomboxController)

import BottomSheetController from "./bottom_sheet_controller"
application.register("bottom-sheet", BottomSheetController)

import BulkPlacesModalController from "./bulk_places_modal_controller"
application.register("bulk-places-modal", BulkPlacesModalController)
import BulkUsersModalController from "./bulk_users_modal_controller"
application.register("bulk-users-modal", BulkUsersModalController)

import CampaignKindFilterController from "./campaign_kind_filter_controller"
application.register("campaign-kind-filter", CampaignKindFilterController)

import CanvasSizeController from "./canvas_size_controller"
application.register("canvas-size", CanvasSizeController)

import CardDragSortController from "./card_drag_sort_controller"
application.register("card-drag-sort", CardDragSortController)

import CardInlineTagsController from "./card_inline_tags_controller"
application.register("card-inline-tags", CardInlineTagsController)

import CardLayoutToggleController from "./card_layout_toggle_controller"
application.register("card-layout-toggle", CardLayoutToggleController)

import CardSortableController from "./card_sortable_controller"
application.register("card-sortable", CardSortableController)

import CardStatusFilterController from "./card_status_filter_controller"
application.register("card-status-filter", CardStatusFilterController)

import CardsFilterController from "./cards_filter_controller"
application.register("cards-filter", CardsFilterController)

import CardsSearchController from "./cards_search_controller"
application.register("cards-search", CardsSearchController)

import CascadingObjectiveSelectController from "./cascading_objective_select_controller"
application.register("cascading-objective-select", CascadingObjectiveSelectController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChartPreviewController from "./chart_preview_controller"
application.register("chart-preview", ChartPreviewController)

import ChatAttachmentsController from "./chat_attachments_controller"
application.register("chat-attachments", ChatAttachmentsController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatDiagnosticLogController from "./chat_diagnostic_log_controller"
application.register("chat-diagnostic-log", ChatDiagnosticLogController)

import ChatIdbListController from "./chat_idb_list_controller"
application.register("chat-idb-list", ChatIdbListController)

import ChatIdbThreadController from "./chat_idb_thread_controller"
application.register("chat-idb-thread", ChatIdbThreadController)

import ChatMenuController from "./chat_menu_controller"
application.register("chat-menu", ChatMenuController)

import ChatMessageEditController from "./chat_message_edit_controller"
application.register("chat-message-edit", ChatMessageEditController)

import ChatNetworkDiagnosticsController from "./chat_network_diagnostics_controller"
application.register("chat-network-diagnostics", ChatNetworkDiagnosticsController)

import ChatNetworkStatusController from "./chat_network_status_controller"
application.register("chat-network-status", ChatNetworkStatusController)

import ChatPresenceController from "./chat_presence_controller"
application.register("chat-presence", ChatPresenceController)

import ChatRailController from "./chat_rail_controller"
application.register("chat-rail", ChatRailController)

import ChatSearchController from "./chat_search_controller"
application.register("chat-search", ChatSearchController)

import ChatSkeletonController from "./chat_skeleton_controller"
application.register("chat-skeleton", ChatSkeletonController)

import ChatStorageDetailController from "./chat_storage_detail_controller"
application.register("chat-storage-detail", ChatStorageDetailController)

import ChatSwUpdateController from "./chat_sw_update_controller"
application.register("chat-sw-update", ChatSwUpdateController)

import ChatSyncController from "./chat_sync_controller"
application.register("chat-sync", ChatSyncController)

import ChatTabsController from "./chat_tabs_controller"
application.register("chat-tabs", ChatTabsController)

import CheckboxesController from "./checkboxes_controller"
application.register("checkboxes", CheckboxesController)

import ClearFieldController from "./clear_field_controller"
application.register("clear-field", ClearFieldController)

import ClientBrandFilterController from "./client_brand_filter_controller"
application.register("client-brand-filter", ClientBrandFilterController)

import ClientLayoutScoresMsoController from "./client_layout_scores_mso_controller"
application.register("client-layout-scores-mso", ClientLayoutScoresMsoController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CollapsibleSectionController from "./collapsible_section_controller"
application.register("collapsible-section", CollapsibleSectionController)

// Registered by hand, NOT via `rails stimulus:manifest:update` -- that
// generator drops the manual registrations further down this file, including
// the survey-* aliases explicitly marked DO NOT REMOVE.
import AriaExpandedController from "./aria_expanded_controller"
application.register("aria-expanded", AriaExpandedController)

import PlanningModalNavController from "./planning_modal_nav_controller"
application.register("planning-modal-nav", PlanningModalNavController)

import ShareableImageNavController from "./shareable_image_nav_controller"
application.register("shareable-image-nav", ShareableImageNavController)

import PlanningTargetSyncController from "./planning_target_sync_controller"
application.register("planning-target-sync", PlanningTargetSyncController)
import PlanningTaskListController from "./planning_task_list_controller"
application.register("planning-task-list", PlanningTaskListController)

import PlanningReviewRefreshController from "./planning_review_refresh_controller"
application.register("planning-review-refresh", PlanningReviewRefreshController)

import PlanningInsightsLinkController from "./planning_insights_link_controller"
application.register("planning-insights-link", PlanningInsightsLinkController)

import CollapsiblePanelController from "./collapsible_panel_controller"
application.register("collapsible-panel", CollapsiblePanelController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import ConfigPreviewController from "./config_preview_controller"
application.register("config-preview", ConfigPreviewController)

import ContactConfirmController from "./contact_confirm_controller"
application.register("contact-confirm", ContactConfirmController)

import ContactModalController from "./contact_modal_controller"
application.register("contact-modal", ContactModalController)

import ContentModalController from "./content_modal_controller"
application.register("content-modal", ContentModalController)

import ContextMenuController from "./context_menu_controller"
application.register("context-menu", ContextMenuController)

import CopyFormController from "./copy_form_controller"
application.register("copy-form", CopyFormController)

import CopySlideController from "./copy_slide_controller"
application.register("copy-slide", CopySlideController)

import CutInReportController from "./cut_in_report_controller"
application.register("cut-in-report", CutInReportController)

import DashboardRefreshController from "./dashboard_refresh_controller"
application.register("dashboard-refresh", DashboardRefreshController)

import DeckEditorController from "./deck_editor_controller"
application.register("deck-editor", DeckEditorController)

import DeckElementContextMenuController from "./deck_element_context_menu_controller"
application.register("deck-element-context-menu", DeckElementContextMenuController)

import DeckImagePickerController from "./deck_image_picker_controller"
application.register("deck-image-picker", DeckImagePickerController)
import DeckTableEditorController from "./deck_table_editor_controller"
application.register("deck-table-editor", DeckTableEditorController)

import DeckMeasuresRowController from "./deck_measures_row_controller"
application.register("deck-measures-row", DeckMeasuresRowController)

import DeckMetricDisclosureController from "./deck_metric_disclosure_controller"
application.register("deck-metric-disclosure", DeckMetricDisclosureController)

import DeckOverrideReasonHovercardController from "./deck_override_reason_hovercard_controller"
application.register("deck-override-reason-hovercard", DeckOverrideReasonHovercardController)

import DeckShowEditorController from "./deck_show_editor_controller"
application.register("deck-show-editor", DeckShowEditorController)

import DeckSlideFlipController from "./deck_slide_flip_controller"
application.register("deck-slide-flip", DeckSlideFlipController)

import DeckSlideHiddenToggleController from "./deck_slide_hidden_toggle_controller"
application.register("deck-slide-hidden-toggle", DeckSlideHiddenToggleController)

import DeckSlidePinsToggleController from "./deck_slide_pins_toggle_controller"
application.register("deck-slide-pins-toggle", DeckSlidePinsToggleController)

import DeckSlidePriorToggleController from "./deck_slide_prior_toggle_controller"
application.register("deck-slide-prior-toggle", DeckSlidePriorToggleController)

import DeckSlidePriorGuardController from "./deck_slide_prior_guard_controller"
application.register("deck-slide-prior-guard", DeckSlidePriorGuardController)

import DeckSlidePermalinkController from "./deck_slide_permalink_controller"
application.register("deck-slide-permalink", DeckSlidePermalinkController)

import DeckVersionModalController from "./deck_version_modal_controller"
application.register("deck-version-modal", DeckVersionModalController)

import DependencySearchController from "./dependency_search_controller"
application.register("dependency-search", DependencySearchController)

import DisableOnClickController from "./disable_on_click_controller"
application.register("disable-on-click", DisableOnClickController)

import DiscardModalController from "./discard_modal_controller"
application.register("discard-modal", DiscardModalController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import DistributionChartController from "./distribution_chart_controller"
application.register("distribution-chart", DistributionChartController)

import DistributionMatrixFilterController from "./distribution_matrix_filter_controller"
application.register("distribution-matrix-filter", DistributionMatrixFilterController)

import DistributionOverviewController from "./distribution_overview_controller"
application.register("distribution-overview", DistributionOverviewController)

import DistributionReportController from "./distribution_report_controller"
application.register("distribution-report", DistributionReportController)

import DistributionTrendChartController from "./distribution_trend_chart_controller"
application.register("distribution-trend-chart", DistributionTrendChartController)

import DistributionTrendChartModalController from "./distribution_trend_chart_modal_controller"
application.register("distribution-trend-chart-modal", DistributionTrendChartModalController)

import DistributionTrendController from "./distribution_trend_controller"
application.register("distribution-trend", DistributionTrendController)

import DocumentDirectUploadController from "./document_direct_upload_controller"
application.register("document-direct-upload", DocumentDirectUploadController)

import DocumentFullscreenController from "./document_fullscreen_controller"
application.register("document-fullscreen", DocumentFullscreenController)

import DoughnutChartController from "./doughnut_chart_controller"
application.register("doughnut-chart", DoughnutChartController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import EmailCopyController from "./email_copy_controller"
application.register("email-copy", EmailCopyController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import ExpandableTextController from "./expandable_text_controller"
application.register("expandable-text", ExpandableTextController)

import ExportLinkController from "./export_link_controller"
application.register("export-link", ExportLinkController)

import FacetedFilterController from "./faceted_filter_controller"
application.register("faceted-filter", FacetedFilterController)

import FacetedSearchController from "./faceted_search_controller"
application.register("faceted-search", FacetedSearchController)

import FieldActivityCalendarController from "./field_activity_calendar_controller"
application.register("field-activity-calendar", FieldActivityCalendarController)

import FieldAutoSyncController from "./field_auto_sync_controller"
application.register("field-auto-sync", FieldAutoSyncController)

import FieldBackButtonController from "./field_back_button_controller"
application.register("field-back-button", FieldBackButtonController)

import FieldBadConnectivityController from "./field_bad_connectivity_controller"
application.register("field-bad-connectivity", FieldBadConnectivityController)

import FieldPinCorrectionController from "./field_pin_correction_controller"
application.register("field-pin-correction", FieldPinCorrectionController)

// Shared by the Field App and the Mission Control "play from the builder"
// surface (card #4465, umbrella #4197) -- see playbook_article_controller.js
import PlaybookArticleController from "./playbook_article_controller"
application.register("playbook-article", PlaybookArticleController)

import FieldBarcodeScannerController from "./field_barcode_scanner_controller"
application.register("field-barcode-scanner", FieldBarcodeScannerController)

import FieldTimeZoneController from "./field_time_zone_controller"
application.register("field-time-zone", FieldTimeZoneController)

import FieldBatteryController from "./field_battery_controller"
application.register("field-battery", FieldBatteryController)

import FieldBatteryPromptController from "./field_battery_prompt_controller"
application.register("field-battery-prompt", FieldBatteryPromptController)

import FieldDeviceInfoController from "./field_device_info_controller"
application.register("field-device-info", FieldDeviceInfoController)

import FieldDiagnosticLogController from "./field_diagnostic_log_controller"
application.register("field-diagnostic-log", FieldDiagnosticLogController)

import FieldFeedController from "./field_feed_controller"
application.register("field-feed", FieldFeedController)

import FieldFlashController from "./field_flash_controller"
application.register("field-flash", FieldFlashController)

import FieldGapFilterController from "./field_gap_filter_controller"
application.register("field-gap-filter", FieldGapFilterController)

import FieldGeolocationController from "./field_geolocation_controller"
application.register("field-geolocation", FieldGeolocationController)

import FieldLogEventController from "./field_log_event_controller"
application.register("field-log-event", FieldLogEventController)

import FieldMenuController from "./field_menu_controller"
application.register("field-menu", FieldMenuController)

import FieldNetworkDiagnosticsController from "./field_network_diagnostics_controller"
application.register("field-network-diagnostics", FieldNetworkDiagnosticsController)

import FieldNetworkStatusController from "./field_network_status_controller"
application.register("field-network-status", FieldNetworkStatusController)

import FieldOfflineFirstBadgeController from "./field_offline_first_badge_controller"
application.register("field-offline-first-badge", FieldOfflineFirstBadgeController)

import FieldPlaceConnectivityController from "./field_place_connectivity_controller"
application.register("field-place-connectivity", FieldPlaceConnectivityController)

import FieldOdometerCameraController from "./field_odometer_camera_controller"
application.register("field-odometer-camera", FieldOdometerCameraController)

import FieldOfflineAppController from "./field_offline_app_controller"
application.register("field-offline-app", FieldOfflineAppController)

import FieldOfflineListController from "./field_offline_list_controller"
application.register("field-offline-list", FieldOfflineListController)

import FieldOfflineModeController from "./field_offline_mode_controller"
application.register("field-offline-mode", FieldOfflineModeController)

import FieldPendingQueueController from "./field_pending_queue_controller"
application.register("field-pending-queue", FieldPendingQueueController)

import FieldNeedsAttentionController from "./field_needs_attention_controller"
application.register("field-needs-attention", FieldNeedsAttentionController)

import FieldPhotoCameraController from "./field_photo_camera_controller"
application.register("field-photo-camera", FieldPhotoCameraController)

import FieldPhotosController from "./field_photos_controller"
application.register("field-photos", FieldPhotosController)

import FieldPlaceScheduleController from "./field_place_schedule_controller"
application.register("field-place-schedule", FieldPlaceScheduleController)

import FieldPlacesMapController from "./field_places_map_controller"
application.register("field-places-map", FieldPlacesMapController)

import FieldPrefetchController from "./field_prefetch_controller"
application.register("field-prefetch", FieldPrefetchController)

import FieldRangingScannerController from "./field_ranging_scanner_controller"
application.register("field-ranging-scanner", FieldRangingScannerController)

import FieldResponseBadgeController from "./field_response_badge_controller"
application.register("field-response-badge", FieldResponseBadgeController)

import FieldResponseSortController from "./field_response_sort_controller"
application.register("field-response-sort", FieldResponseSortController)

import FieldResponseStatusController from "./field_response_status_controller"
application.register("field-response-status", FieldResponseStatusController)

import FieldSaveBackController from "./field_save_back_controller"
application.register("field-save-back", FieldSaveBackController)

import FieldScheduleController from "./field_schedule_controller"
application.register("field-schedule", FieldScheduleController)

import FieldSearchController from "./field_search_controller"
application.register("field-search", FieldSearchController)

import FieldSectionToggleController from "./field_section_toggle_controller"
application.register("field-section-toggle", FieldSectionToggleController)

import FieldSettingsController from "./field_settings_controller"
application.register("field-settings", FieldSettingsController)

import FieldShelfFilterController from "./field_shelf_filter_controller"
application.register("field-shelf-filter", FieldShelfFilterController)

import FieldShiftKmController from "./field_shift_km_controller"
application.register("field-shift-km", FieldShiftKmController)

import FieldSkeletonController from "./field_skeleton_controller"
application.register("field-skeleton", FieldSkeletonController)

import FieldStartResponseController from "./field_start_response_controller"
application.register("field-start-response", FieldStartResponseController)

import FieldStockRangingController from "./field_stock_ranging_controller"
application.register("field-stock-ranging", FieldStockRangingController)

import FieldStorageDetailController from "./field_storage_detail_controller"
application.register("field-storage-detail", FieldStorageDetailController)

import FieldStorageUsageController from "./field_storage_usage_controller"
application.register("field-storage-usage", FieldStorageUsageController)

import FieldStorageHealthController from "./field_storage_health_controller"
application.register("field-storage-health", FieldStorageHealthController)

import FieldPhotoVaultController from "./field_photo_vault_controller"
application.register("field-photo-vault", FieldPhotoVaultController)

import FieldMissionCountsController from "./field_mission_counts_controller"
application.register("field-mission-counts", FieldMissionCountsController)

import FieldSwUpdateController from "./field_sw_update_controller"
application.register("field-sw-update", FieldSwUpdateController)

import FieldSyncBannerController from "./field_sync_banner_controller"
application.register("field-sync-banner", FieldSyncBannerController)

import FieldSyncController from "./field_sync_controller"
application.register("field-sync", FieldSyncController)

import FieldSyncPageController from "./field_sync_page_controller"
application.register("field-sync-page", FieldSyncPageController)

import FieldCardsController from "./field_cards_controller"
application.register("field-cards", FieldCardsController)

import FieldCardNotesController from "./field_card_notes_controller"
application.register("field-card-notes", FieldCardNotesController)

import FieldTodayIdbController from "./field_today_idb_controller"
application.register("field-today-idb", FieldTodayIdbController)

import FieldTodaySortController from "./field_today_sort_controller"
application.register("field-today-sort", FieldTodaySortController)

import FieldViewToggleController from "./field_view_toggle_controller"
application.register("field-view-toggle", FieldViewToggleController)

import FormController from "./form_controller"
application.register("form", FormController)

import FrameRetryController from "./frame_retry_controller"
application.register("frame-retry", FrameRetryController)

import FullscreenToggleController from "./fullscreen_toggle_controller"
application.register("fullscreen-toggle", FullscreenToggleController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import GaugeChartController from "./gauge_chart_controller"
application.register("gauge-chart", GaugeChartController)

import GlobalSearchHotkeyController from "./global_search_hotkey_controller"
application.register("global-search-hotkey", GlobalSearchHotkeyController)

import HovercardController from "./hovercard_controller"
application.register("hovercard", HovercardController)

import Hub__ChartDataTableController from "./hub/chart_data_table_controller"
application.register("hub--chart-data-table", Hub__ChartDataTableController)

import Hub__LiveUpdateIndicatorController from "./hub/live_update_indicator_controller"
application.register("hub--live-update-indicator", Hub__LiveUpdateIndicatorController)

import Hub__ObjectiveChartController from "./hub/objective_chart_controller"
application.register("hub--objective-chart", Hub__ObjectiveChartController)

import ImageAnnotationController from "./image_annotation_controller"
application.register("image-annotation", ImageAnnotationController)

import ImageAttributionController from "./image_attribution_controller"
application.register("image-attribution", ImageAttributionController)

import ImageContextMenuController from "./image_context_menu_controller"
application.register("image-context-menu", ImageContextMenuController)

import ImageCropHomographyController from "./image_crop_homography_controller"
application.register("image-crop-homography", ImageCropHomographyController)

import ImageModeController from "./image_mode_controller"
application.register("image-mode", ImageModeController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import IndieCutInReportController from "./indie_cut_in_report_controller"
application.register("indie-cut-in-report", IndieCutInReportController)

import IndiesCycleSummaryController from "./indies_cycle_summary_controller"
application.register("indies-cycle-summary", IndiesCycleSummaryController)

import IndiesMissionGapsFilterController from "./indies_mission_gaps_filter_controller"
application.register("indies-mission-gaps-filter", IndiesMissionGapsFilterController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InlineSaveController from "./inline_save_controller"
application.register("inline-save", InlineSaveController)

import LinkableHeadingsController from "./linkable_headings_controller"
application.register("linkable-headings", LinkableHeadingsController)

import LiveDurationController from "./live_duration_controller"
application.register("live-duration", LiveDurationController)

import LiveMapPlacesController from "./live_map_places_controller"
application.register("live-map-places", LiveMapPlacesController)

import MapController from "./map_controller"
application.register("map", MapController)

import MeasureAgainstToggleController from "./measure_against_toggle_controller"
application.register("measure-against-toggle", MeasureAgainstToggleController)

import MeasureModelController from "./measure_model_controller"
application.register("measure-model", MeasureModelController)

import MentionsController from "./mentions_controller"
application.register("mentions", MentionsController)

import MergeFormController from "./merge_form_controller"
application.register("merge-form", MergeFormController)

import MissionFilterController from "./mission_filter_controller"
application.register("mission-filter", MissionFilterController)

import MissionResultsModalController from "./mission_results_modal_controller"
application.register("mission-results-modal", MissionResultsModalController)

import MissionSortController from "./mission_sort_controller"
application.register("mission-sort", MissionSortController)

import MissionTaskModalController from "./mission_task_modal_controller"
application.register("mission-task-modal", MissionTaskModalController)

import MissionTaskResultsModalController from "./mission_task_results_modal_controller"
application.register("mission-task-results-modal", MissionTaskResultsModalController)

import MissionTaskTrackingModalController from "./mission_task_tracking_modal_controller"
application.register("mission-task-tracking-modal", MissionTaskTrackingModalController)

import MobileIceCreamLoaderController from "./mobile_ice_cream_loader_controller"
application.register("mobile-ice-cream-loader", MobileIceCreamLoaderController)

import ModalCloserController from "./modal_closer_controller"
application.register("modal-closer", ModalCloserController)

import NavigatableController from "./navigatable_controller"
application.register("navigatable", NavigatableController)

import NewChatController from "./new_chat_controller"
application.register("new-chat", NewChatController)

import NewTabGuardController from "./new_tab_guard_controller"
application.register("new-tab-guard", NewTabGuardController)

import NotificationBellController from "./notification_bell_controller"
application.register("notification-bell", NotificationBellController)

import ObjectiveDataSourceController from "./objective_data_source_controller"
application.register("objective-data-source", ObjectiveDataSourceController)

import ObjectiveMiniChartController from "./objective_mini_chart_controller"
application.register("objective-mini-chart", ObjectiveMiniChartController)

import ObjectiveStatusFilterController from "./objective_status_filter_controller"
application.register("objective-status-filter", ObjectiveStatusFilterController)

import ObjectiveViewToggleController from "./objective_view_toggle_controller"
application.register("objective-view-toggle", ObjectiveViewToggleController)

import Objectives__AggregateReportRefreshController from "./objectives/aggregate_report_refresh_controller"
application.register("objectives--aggregate-report-refresh", Objectives__AggregateReportRefreshController)

import OffersController from "./offers_controller"
application.register("offers", OffersController)

import PaneSelectorController from "./pane_selector_controller"
application.register("pane-selector", PaneSelectorController)

import PersistTabsController from "./persist_tabs_controller"
application.register("persist-tabs", PersistTabsController)

import PhaseProjectAssigneeFilterController from "./phase_project_assignee_filter_controller"
application.register("phase-project-assignee-filter", PhaseProjectAssigneeFilterController)

import PickerNavController from "./picker_nav_controller"
application.register("picker-nav", PickerNavController)

import PlaceFilterController from "./place_filter_controller"
application.register("place-filter", PlaceFilterController)

import PlaceHovercardController from "./place_hovercard_controller"
application.register("place-hovercard", PlaceHovercardController)

import PlaceOwnerHovercardController from "./place_owner_hovercard_controller"
application.register("place-owner-hovercard", PlaceOwnerHovercardController)

import PlaceSortController from "./place_sort_controller"
application.register("place-sort", PlaceSortController)

import PlanogramBaySelectorController from "./planogram_bay_selector_controller"
application.register("planogram-bay-selector", PlanogramBaySelectorController)

import PlanogramBaysController from "./planogram_bays_controller"
application.register("planogram-bays", PlanogramBaysController)

import PlanogramBaysSearchController from "./planogram_bays_search_controller"
application.register("planogram-bays-search", PlanogramBaysSearchController)

import PlanogramCategoryFilterController from "./planogram_category_filter_controller"
application.register("planogram-category-filter", PlanogramCategoryFilterController)

import ProductHierarchyCascadeController from "./product_hierarchy_cascade_controller"
application.register("product-hierarchy-cascade", ProductHierarchyCascadeController)

import ProductHierarchyMultiCascadeController from "./product_hierarchy_multi_cascade_controller"
application.register("product-hierarchy-multi-cascade", ProductHierarchyMultiCascadeController)

import ProductHovercardController from "./product_hovercard_controller"
application.register("product-hovercard", ProductHovercardController)

import ProductImagesDropzoneController from "./product_images_dropzone_controller"
application.register("product-images-dropzone", ProductImagesDropzoneController)

import ProgramFormController from "./program_form_controller"
application.register("program-form", ProgramFormController)

import ProjectFormController from "./project_form_controller"
application.register("project-form", ProjectFormController)


import PushNotificationsController from "./push_notifications_controller"
application.register("push-notifications", PushNotificationsController)

import Pwa__DiagnosticLogController from "./pwa/diagnostic_log_controller"
application.register("pwa--diagnostic-log", Pwa__DiagnosticLogController)

import Pwa__NetworkDiagnosticsController from "./pwa/network_diagnostics_controller"
application.register("pwa--network-diagnostics", Pwa__NetworkDiagnosticsController)

import Pwa__NetworkStatusController from "./pwa/network_status_controller"
application.register("pwa--network-status", Pwa__NetworkStatusController)

import Pwa__OfflineModeController from "./pwa/offline_mode_controller"
application.register("pwa--offline-mode", Pwa__OfflineModeController)

import PwaClockController from "./pwa_clock_controller"
application.register("pwa-clock", PwaClockController)

import PwaImageViewerController from "./pwa_image_viewer_controller"
application.register("pwa-image-viewer", PwaImageViewerController)

import PwaReloadController from "./pwa_reload_controller"
application.register("pwa-reload", PwaReloadController)

import RangingReviewController from "./ranging_review_controller"
application.register("ranging-review", RangingReviewController)

import RangingReviewFilterController from "./ranging_review_filter_controller"
application.register("ranging-review-filter", RangingReviewFilterController)

import RangingRowController from "./ranging_row_controller"
application.register("ranging-row", RangingRowController)

import RecalculateButtonController from "./recalculate_button_controller"
application.register("recalculate-button", RecalculateButtonController)

import RedeployPreviewController from "./redeploy_preview_controller"
application.register("redeploy-preview", RedeployPreviewController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import ReferencesController from "./references_controller"
application.register("references", ReferencesController)

import ReleaseOrderSortableController from "./release_order_sortable_controller"
application.register("release-order-sortable", ReleaseOrderSortableController)

import ReplyToggleController from "./reply_toggle_controller"
application.register("reply-toggle", ReplyToggleController)

import ResponseModalController from "./response_modal_controller"
application.register("response-modal", ResponseModalController)

import ResultSummaryModalController from "./result_summary_modal_controller"
application.register("result-summary-modal", ResultSummaryModalController)

import ResponseScheduleController from "./response_schedule_controller"
application.register("response-schedule", ResponseScheduleController)

import ResponseStatusFilterController from "./response_status_filter_controller"
application.register("response-status-filter", ResponseStatusFilterController)

import ResponseTabsController from "./response_tabs_controller"
application.register("response-tabs", ResponseTabsController)

import ResultCardSortableController from "./result_card_sortable_controller"
application.register("result-card-sortable", ResultCardSortableController)

import ResultFormController from "./result_form_controller"
application.register("result-form", ResultFormController)

import ReviewActionsController from "./review_actions_controller"
application.register("review-actions", ReviewActionsController)

import ReviewActionsTriggerController from "./review_actions_trigger_controller"
application.register("review-actions-trigger", ReviewActionsTriggerController)

import ReviewStatusController from "./review_status_controller"
application.register("review-status", ReviewStatusController)

import ReviewWaffleChartController from "./review_waffle_chart_controller"
application.register("review-waffle-chart", ReviewWaffleChartController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import RunbookGraphController from "./runbook_graph_controller"
application.register("runbook-graph", RunbookGraphController)

import RunbookNodeDetailModalController from "./runbook_node_detail_modal_controller"
application.register("runbook-node-detail-modal", RunbookNodeDetailModalController)

import RunbookNodeSortableController from "./runbook_node_sortable_controller"
application.register("runbook-node-sortable", RunbookNodeSortableController)

import SaveIndicatorController from "./save_indicator_controller"
application.register("save-indicator", SaveIndicatorController)

import ScoreAdjustController from "./score_adjust_controller"
application.register("score-adjust", ScoreAdjustController)

import ScoreFormController from "./score_form_controller"
application.register("score-form", ScoreFormController)

import SectorRetailerFilterController from "./sector_retailer_filter_controller"
application.register("sector-retailer-filter", SectorRetailerFilterController)

import SelectorsController from "./selectors_controller"
application.register("selectors", SelectorsController)

import SignalMapController from "./signal_map_controller"
application.register("signal-map", SignalMapController)

import SignalPollerController from "./signal_poller_controller"
application.register("signal-poller", SignalPollerController)

import SlideFeedbackStatusController from "./slide_feedback_status_controller"
application.register("slide-feedback-status", SlideFeedbackStatusController)

import SlideReviewStatusController from "./slide_review_status_controller"
application.register("slide-review-status", SlideReviewStatusController)

import SlimController from "./slim_controller"
application.register("slim", SlimController)

import SlimFilterController from "./slim_filter_controller"
application.register("slim-filter", SlimFilterController)

import SnipController from "./snip_controller"
application.register("snip", SnipController)

import SprintBoardController from "./sprint_board_controller"
application.register("sprint-board", SprintBoardController)

import SprintColumnPaginationController from "./sprint_column_pagination_controller"
application.register("sprint-column-pagination", SprintColumnPaginationController)

import SprintTileDropdownController from "./sprint_tile_dropdown_controller"
application.register("sprint-tile-dropdown", SprintTileDropdownController)

import SprintViewToggleController from "./sprint_view_toggle_controller"
application.register("sprint-view-toggle", SprintViewToggleController)

import StepCheckboxController from "./step_checkbox_controller"
application.register("step-checkbox", StepCheckboxController)

import StepEditController from "./step_edit_controller"
application.register("step-edit", StepEditController)

import StocksController from "./stocks_controller"
application.register("stocks", StocksController)

import StripBlankFieldsController from "./strip_blank_fields_controller"
application.register("strip-blank-fields", StripBlankFieldsController)

import SubjectPickerController from "./subject_picker_controller"
application.register("subject-picker", SubjectPickerController)

import SubmitSpinnerController from "./submit_spinner_controller"
application.register("submit-spinner", SubmitSpinnerController)

import SupportCardsTabsController from "./support_cards_tabs_controller"
application.register("support-cards-tabs", SupportCardsTabsController)

import SurveyPreviewModalController from "./survey_preview_modal_controller"
application.register("survey-preview-modal", SurveyPreviewModalController)

import Surveys__CreatorBaseController from "./surveys/creator_base_controller"
application.register("surveys--creator-base", Surveys__CreatorBaseController)

import Surveys__CreatorController from "./surveys/creator_controller"
application.register("surveys--creator", Surveys__CreatorController)

import Surveys__DashboardController from "./surveys/dashboard_controller"
application.register("surveys--dashboard", Surveys__DashboardController)

import Surveys__ResultController from "./surveys/result_controller"
application.register("surveys--result", Surveys__ResultController)

import Surveys__ResultEditorController from "./surveys/result_editor_controller"
application.register("surveys--result-editor", Surveys__ResultEditorController)

import Surveys__ShareableResultController from "./surveys/shareable_result_controller"
application.register("surveys--shareable-result", Surveys__ShareableResultController)

import Surveys__SurveyBaseController from "./surveys/survey_base_controller"
application.register("surveys--survey-base", Surveys__SurveyBaseController)

import Surveys__TabulatorController from "./surveys/tabulator_controller"
application.register("surveys--tabulator", Surveys__TabulatorController)

import SwitchController from "./switch_controller"
application.register("switch", SwitchController)

import TableController from "./table_controller"
application.register("table", TableController)

import TableFilterController from "./table_filter_controller"
application.register("table-filter", TableFilterController)

import TableOfContentsController from "./table_of_contents_controller"
application.register("table-of-contents", TableOfContentsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TargetValueController from "./target_value_controller"
application.register("target-value", TargetValueController)

import TrackingSetupToggleController from "./tracking_setup_toggle_controller"
application.register("tracking-setup-toggle", TrackingSetupToggleController)

import TrackingTabFilterController from "./tracking_tab_filter_controller"
application.register("tracking-tab-filter", TrackingTabFilterController)

import TrafficLightReportController from "./traffic_light_report_controller"
application.register("traffic-light-report", TrafficLightReportController)

import TemplatePreviewController from "./template_preview_controller"
application.register("template-preview", TemplatePreviewController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import TioLinesController from "./tio_lines_controller"
application.register("tio-lines", TioLinesController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TruncateController from "./truncate_controller"
application.register("truncate", TruncateController)

import TurboGetController from "./turbo_get_controller"
application.register("turbo-get", TurboGetController)

import TvKioskController from "./tv_kiosk_controller"
application.register("tv-kiosk", TvKioskController)

import UploadPollController from "./upload_poll_controller"
application.register("upload-poll", UploadPollController)

import UrlUpdaterController from "./url_updater_controller"
application.register("url-updater", UrlUpdaterController)

import UserHovercardController from "./user_hovercard_controller"
application.register("user-hovercard", UserHovercardController)

import WaffleChartController from "./waffle_chart_controller"
application.register("waffle-chart", WaffleChartController)

import WaffleTooltipController from "./waffle_tooltip_controller"
application.register("waffle-tooltip", WaffleTooltipController)

import WorkflowSelectController from "./workflow_select_controller"
application.register("workflow-select", WorkflowSelectController)

import WorkflowTemplateEditorController from "./workflow_template_editor_controller"
application.register("workflow-template-editor", WorkflowTemplateEditorController)

// Survey controller aliases -- templates use "survey-*" not "surveys--*"
// DO NOT REMOVE these aliases. See feedback_survey_stimulus_aliases.md.
application.register("survey-creator-base", Surveys__CreatorBaseController)
application.register("survey-creator", Surveys__CreatorController)
application.register("survey-dashboard", Surveys__DashboardController)
application.register("survey-result", Surveys__ResultController)
application.register("survey-result-editor", Surveys__ResultEditorController)
application.register("survey-shareable-result", Surveys__ShareableResultController)
application.register("survey-base", Surveys__SurveyBaseController)
application.register("survey-tabulator", Surveys__TabulatorController)

import JanelaFrameController from "@retail-tasker/janela/frame_controller"
application.register("janela--frame", JanelaFrameController)

import JanelaChartController from "@retail-tasker/janela/chart_controller"
application.register("janela--chart", JanelaChartController)

import EmbedThemeController from "./embed_theme_controller"
application.register("embed-theme", EmbedThemeController)

import DeckClockController from "./deck_clock_controller"
application.register("deck-clock", DeckClockController)

import PlaybookChapterSortableController from "./playbook_chapter_sortable_controller"
application.register("playbook-chapter-sortable", PlaybookChapterSortableController)

import PlaybookEntrySortableController from "./playbook_entry_sortable_controller"
application.register("playbook-entry-sortable", PlaybookEntrySortableController)

import VideoConnectionGateController from "./video_connection_gate_controller"
application.register("video-connection-gate", VideoConnectionGateController)
